import { defineStore } from 'pinia';
import SubmitService from '@/service/SubmitService';
import { ERR_NETWORK } from '@/constants';

export const useSubmitQuoteStore = defineStore('handleSubmit', {
  state: () => ({
    dataSubmit: {},
    pdf: '',
    quoteId: '',
    isLoading: false
  }),
  getters: {
    selectDataSubmit: (state) => state.dataSubmit,
    selectPDF: (state) => state.pdf,
    selectQuoteId: (state) => state.quoteId,
    selectIsLoading: (state) => state.isLoading
  },
  actions: {
    handleSubmit(payload, noLoading, openModalTimeOut, openModalErrorPricing) {
      if (!noLoading) {
        this.isLoading = true;
      }
      const submitService = new SubmitService();
      return submitService
        .onSubmit(payload)
        .then((res) => {
          if (res) {
            this.updateHandleSubmit(res.data);
            this.updatePDF(res.data.pdf);
            this.updateQuoteId(res.data.sk);
          }
          return res;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response?.status === 504 || error?.code === ERR_NETWORK) {
            if (openModalTimeOut) {
              openModalTimeOut();
              throw new Error('Timeout error');
            }
          }
          if (error.response?.status === 406) {
            if (openModalErrorPricing) {
              openModalErrorPricing();
            }
          }

          throw new Error('An error occurred during form submission.');
        })
        .finally(() => (this.isLoading = false));
    },
    updateHandleSubmit(payload) {
      this.dataSubmit = payload;
    },
    updatePDF(payload) {
      this.pdf = payload;
    },
    updateQuoteId(payload) {
      this.quoteId = payload;
    }
  }
});
